"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeListItems = exports.TIME_PARSE_FORMATS = void 0;
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _setHours = _interopRequireDefault(require("date-fns/setHours"));
var _setMinutes = _interopRequireDefault(require("date-fns/setMinutes"));
var _setSeconds = _interopRequireDefault(require("date-fns/setSeconds"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var TIME_PARSE_FORMATS = exports.TIME_PARSE_FORMATS = ['H', 'Hmm', 'H:mm', 'H.mm.ss', 'Hmmss', 'H:mm:ss', 'ha', 'hamm', 'hmma', 'h:mma', 'h:mm a', 'h.mma', 'h.mm a', 'h.mm.ssa', 'h.mm.ss a', 'h:mm:ss a', 'h:mm:ss a', 'hmmssa'];
var getTimeListItems = exports.getTimeListItems = (0, _memoizeOne["default"])(function (timeDisplayFormat) {
  var listItems = [];
  var minutes = [0, 15, 30, 45];
  for (var h = 0; h < 24; h += 1) {
    var _iterator = _createForOfIteratorHelper(minutes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var m = _step.value;
        var listItem = {
          time: {
            hours: h,
            minutes: m,
            seconds: 0
          },
          formatted: (0, _format["default"])((0, _setHours["default"])((0, _setMinutes["default"])((0, _setSeconds["default"])(new Date(), 0 || 0), m), h), timeDisplayFormat)
        };
        listItems.push(listItem);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return listItems;
});